const state = {
  error: null,
  ipBans: [],
  macBans: [],
  affectedUsers: []
}

const getters = {
  systemBanError: state => state.error,
  systemBansIPs: state => state.ipBans,
  systemBansMACs: state => state.macBans,
  affectedUsers: state => state.affectedUsers
}

const actions = {
  setError ({commit}, data) {
    commit('setError', data.data)
  },
  getSystemBans ({commit}, data) {
      commit('setSystemBans', data.data)
  },
  getAffectedUsers ({commit}, data) {
      commit('setAffectedUsers', data.data)
  }
}

const mutations = {
  setError (state, error) {
    state.error = {error: error, time: Date.now()}
  },
  setSystemBans (state, data) {
      state.ipBans = data.ips || []
      state.macBans = data.macs || []
  },
  setAffectedUsers (state, data) {
      state.affectedUsers = data || []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}